// Generated by CoffeeScript 2.7.0
var Admin__Dataclip__ResponsesController;

import ResponsesTable from 'trunks/vue/admin/compositions/datable_table/responses_table.js';

import {
  NewDataclipsNavigation
} from 'trunks/vue/admin/compositions/dataclip/navigation.js';

export default Admin__Dataclip__ResponsesController = class Admin__Dataclip__ResponsesController extends Skylark.App.BaseController {
  index() {
    var dataclip, dataclipable, main_el, raw_dataclip, responseable_gid, responses_table_el;
    main_el = DomMaster.find('main');
    responses_table_el = main_el.find('#js_responses_container');
    raw_dataclip = _.clone(this.getVars('dataclip'));
    dataclip = _.omit(raw_dataclip, 'dataclipable');
    responseable_gid = new Skylark.Libs.GlobalID(dataclip.gid);
    dataclipable = raw_dataclip.dataclipable;
    this._setupDataclipsNavigation(dataclip, dataclipable);
    this._initDestroyDataclipConfirm(responseable_gid, dataclipable);
    return new ResponsesTable({
      el: responses_table_el.node,
      propsData: {
        fieldable: new Skylark.App.Model.Form(dataclipable),
        datableGID: responseable_gid,
        preserveredFilters: dataclip != null ? dataclip.conditions : void 0,
        visibleFieldIds: dataclip.field_ids
      }
    });
  }

  _setupDataclipsNavigation(dataclip, dataclipable) {
    var options, ref;
    if ((ref = this.constructor.$dataclipsNavigation) != null ? ref.$el.offsetParent : void 0) {
      return;
    }
    options = {
      responseableManaged: this.getVars('responseableManaged')
    };
    return this.constructor.$dataclipsNavigation = NewDataclipsNavigation(dataclip, dataclipable, options);
  }

  _initDestroyDataclipConfirm(dataclip_gid, dataclipable) {
    var dataclipable_gid, head_actions_el;
    dataclipable_gid = new Skylark.Libs.GlobalID(dataclipable.gid);
    head_actions_el = DomMaster.find('.header-actions');
    return head_actions_el.node.proxy('click', '.js_delete_dataclip', function() {
      var confirmVm;
      confirmVm = Skylark.Bridge.newConfirm({
        icon: '<i class="slp-warning-circle-o"></i>',
        title: '删除视图？',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      });
      return confirmVm.$on('ensureClicked', function() {
        return Skylark.Libs.Ajax.delete(`/admin${dataclip_gid.toPath()}.json`, {
          success: function() {
            window.location = `/admin/${dataclipable_gid.toPath()}`;
            return Skylark.Bridge.newAlertify('删除成功', {
              type: 'success'
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除失败', {
              type: 'error'
            });
          }
        });
      });
    });
  }

};
